import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { glass } from "./portal";
import { Search, BookOpen } from "lucide-react";

export const Route = createFileRoute("/_authenticated/portal/knowledge")({
  component: KnowledgePage,
});

function KnowledgePage() {
  const [q, setQ] = useState("");
  const { data: articles } = useQuery({
    queryKey: ["portal", "kb"],
    queryFn: async () => (await supabase.from("kb_articles").select("*").eq("is_published", true).order("sort_order")).data ?? [],
  });
  const filtered = (articles ?? []).filter((a) => (a.title + " " + (a.excerpt ?? "")).toLowerCase().includes(q.toLowerCase()));
  const byCat = filtered.reduce<Record<string, typeof filtered>>((acc, a) => {
    (acc[a.category] ??= []).push(a);
    return acc;
  }, {});

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Knowledge Base</h1>
        <p className="text-white/60 mt-1">Guide, FAQ, tutorial video e documentazione.</p>
      </div>
      <div className={`${glass} p-4 flex items-center gap-2`}>
        <Search className="h-4 w-4 text-white/50" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca articoli..." className="flex-1 bg-transparent text-sm focus:outline-none" />
      </div>

      {Object.entries(byCat).map(([cat, arts]) => (
        <div key={cat}>
          <div className="text-xs uppercase tracking-widest text-white/40 mb-3">{cat}</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {arts.map((a) => (
              <div key={a.id} className={`${glass} p-5 hover:bg-white/[0.06] transition cursor-pointer`}>
                <BookOpen className="h-5 w-5 text-white/60" />
                <div className="mt-2 font-semibold">{a.title}</div>
                {a.excerpt && <p className="text-sm text-white/60 mt-1">{a.excerpt}</p>}
                {a.video_url && <div className="mt-2 text-xs text-fuchsia-300">Video tutorial ↗</div>}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
